import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Select, MenuItem, FormControl } from "@mui/material";

export default function DataGridPaginator({ pageObject, updatePagination }) {
  const handlePageSizeChange = (event) => {
    updatePagination({
      page: 0, // Reset to first page when changing page size
      pageSize: event.target.value,
    });
  };

  return (
    <MDBox
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mt: 2,
        px: 2,
      }}
    >
      <MDBox sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <MDTypography variant="button" color="text">
          {`Mostrando ${
            pageObject.page * pageObject.perPage + 1
          } até ${Math.min(
            (pageObject.page + 1) * pageObject.perPage,
            pageObject.totalRows
          )} de ${pageObject.totalRows} registros`}
        </MDTypography>
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <Select
            value={pageObject.perPage}
            onChange={handlePageSizeChange}
            size="small"
            sx={{ height: 32 }}
          >
            <MenuItem value={50}>50 por página</MenuItem>
            <MenuItem value={100}>100 por página</MenuItem>
          </Select>
        </FormControl>
      </MDBox>

      <MDBox sx={{ display: "flex", gap: 1 }}>
        <MDButton
          color="info"
          variant="contained"
          size="small"
          onClick={() =>
            updatePagination({
              page: 0,
              pageSize: pageObject.perPage,
            })
          }
          disabled={pageObject.page === 0}
        >
          Primeira
        </MDButton>
        <MDButton
          color="info"
          variant="contained"
          size="small"
          onClick={() =>
            updatePagination({
              page: pageObject.page - 1,
              pageSize: pageObject.perPage,
            })
          }
          disabled={pageObject.page === 0}
        >
          Anterior
        </MDButton>
        <MDTypography variant="button" color="text" sx={{ px: 2, py: 1 }}>
          Página {pageObject.page + 1} de{" "}
          {Math.ceil(pageObject.totalRows / pageObject.perPage)}
        </MDTypography>
        <MDButton
          color="info"
          variant="contained"
          size="small"
          onClick={() =>
            updatePagination({
              page: pageObject.page + 1,
              pageSize: pageObject.perPage,
            })
          }
          disabled={
            pageObject.page >=
            Math.ceil(pageObject.totalRows / pageObject.perPage) - 1
          }
        >
          Próxima
        </MDButton>
        <MDButton
          color="info"
          variant="contained"
          size="small"
          onClick={() =>
            updatePagination({
              page: Math.ceil(pageObject.totalRows / pageObject.perPage) - 1,
              pageSize: pageObject.perPage,
            })
          }
          disabled={
            pageObject.page >=
            Math.ceil(pageObject.totalRows / pageObject.perPage) - 1
          }
        >
          Última
        </MDButton>
      </MDBox>
    </MDBox>
  );
}
